export default function currencyFormat(value: number | any) {
    // return new Intl.NumberFormat('id-ID', {style: 'currency', currency: 'IDR', maximumFractionDigits:0 }).format(value)
     return new Intl.NumberFormat('id-ID', {style: 'currency', currency: 'IDR', minimumFractionDigits:0, maximumFractionDigits:2 }).format(value);
}
